//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import { PRIORITY_TYPES, TASKS_STATUS, getTaskStatus } from "@/components/tasks/myTeamsTasks/constants";
import { setPluginIcon } from "@/assets/js/appFunc";
import { APP_DATE_DOT_FORMAT, APP_DATE_DOT_DMY_FORMAT, CATALOGS_TIME_LINE_FORMAT_SHOW } from "@/assets/js/appConfig";
import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { MORE_OPTIONS } from "./ReportsTable.const";

export default {
    name: "ReportsCellCustomBody",
    components: {
        AQButton,
        AQTooltip,
        AQMenu,
        AQBadge,
        AQChip,
        membersListInfo
    },
    filters: {
        dateFormatter(dateToFormat, time) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(" ") : "";
            let responseData = "";
            if (newData) {
                responseData = time ? newData[1] : newData[0];
            }
            return responseData;
        },
        dataModelFormatter(data, type) {
            let response = data;
            if (data && ["time", "date"].includes(type)) {
                if (type === "time") {
                    const [hours, minutes, seconds] = data.split(/[^\d]/);
                    let newData;
                    if (data.endsWith("Z")) {
                        newData = date.adjustDate(new Date(), { hours, minutes, seconds }, true);
                    } else {
                        const checkDate = value => (value < 10 ? `0${value}` : value);
                        const newDate = new Date();
                        const dateArr = [newDate.getFullYear(), checkDate(newDate.getMonth() + 1), checkDate(newDate.getDate())];
                        newData = `${dateArr.join("-")}T${data}`;
                    }
                    response = date.formatDate(newData, CATALOGS_TIME_LINE_FORMAT_SHOW);
                } else {
                    response = date.formatDate(data, APP_DATE_DOT_DMY_FORMAT);
                }
            }
            return response || "-";
        },
        assigneesTotalNumber(data) {
            return `+${(data.users.length + data.groups.length) - 1}`;
        }
    },
    props: {
        instanceTab: { type: Boolean, default: false },
        cellConfig: { type: Object, default: () => {} },
        isDataModel: { type: Boolean, default: false },
        data: { type: Object, default: () => {} },
        assignees: { type: Object, default: () => {} },
        rowIdx: { type: Number, default: 0 },
        isOwner: { type: Boolean, default: false },
        hasWriteRT: { type: Boolean, default: false },
        hasWriteUC: { type: Boolean, default: false },
        isBulkMode: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        isSearchPage: { type: Boolean, default: false },
        customInterface: { type: Boolean, default: false },
        enableInstanceNameCol: { type: Boolean, default: false },
        changeValueInstActivity: { type: Boolean, default: false }
    },
    data() {
        return {
            allTasksPriority: PRIORITY_TYPES,
            allTasksStatus: TASKS_STATUS,
            moreOptions: MORE_OPTIONS,
            moreActionModel: [],
            showInstanceTooltip: true,
            showTooltip: null
        };
    },
    computed: {
        cellType() {
            return this.cellConfig.name;
        },
        isBlockchainEvent() {
            return this.data.taskType === "BLOCKCHAIN_EVENT_PLUGIN";
        },
        hasAssignees() {
            return (this.assignees.users && this.assignees.users.length) || (this.assignees.groups && this.assignees.groups.length);
        },
        setCreationDateValue() {
            return this.instanceTab ? this.data.startDate : this.data.creationDate;
        },
        showViewDetails() {
            return this.instanceTab ? (this.customInterface && this.isSearchPage) || (this.data.endActivityId && this.data.systemStatus === "COMPLETED")
                : (this.data.guiId && !this.isBlockchainEvent);
        },
        showSwitchTab() {
            return !(this.data.endActivityId && this.data.systemStatus === "COMPLETED");
        },
        setIdActionBtn() {
            return this.instanceTab ? `reports-instance-view-${this.data.instanceId}` : `reports-task-view-${this.data.taskId}`;
        },
        getInstanceActivTooltip() {
            return this.$t(`liveView.tasksInstances.${this.data.systemStatus === "FAILED" ? "tooltipInstanceFailed" : "tooltipInstance"}`);
        },
        getInstanceActivDisable() {
            return this.data.systemStatus === "FAILED";
        },
        assignmentChipType() {
            let type = "";
            if (this.assignees.users && this.assignees.users.length) {
                type = this.assignees.users[0].status === "DISABLED" ? "disabledUser" : "user";
            } else if (this.assignees.groups && this.assignees.groups.length) {
                type = "group";
            }
            return type;
        }
    },
    methods: {
        setPluginIcon,
        getTaskStatus,
        checkIfEllipsis(ref) {
            const { [ref]: el } = this.$refs;
            if (el) {
                this.showTooltip = el.scrollHeight > el.clientHeight;
            }
        },
        setTaskFirstAssignee(data) {
            let firstAssignee = "";
            if (data.users.length) {
                if (data.users[0].firstName || data.users[0].lastName) {
                    const [user] = data.users;
                    firstAssignee = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}`.trim() : (user.firstName || user.lastName);
                } else {
                    firstAssignee = data.users[0].email;
                }
            } else {
                firstAssignee = data.groups[0].name;
            }
            return firstAssignee;
        },
        switchToTasks() {
            if (!this.getInstanceActivDisable) {
                this.showInstanceTooltip = false;
                this.$emit("switchTab");
            }
        },
        switchToInstances() {
            if (!this.instanceTab && !this.enableInstanceNameCol) {
                this.$emit("switchTab", true);
            }
        },
        getTaskAssignees() {
            this.$emit("getTaskAssignees");
        },
        setDeadlineExpirationFormat(data) {
            const isZeroValue = data === 0;
            let response = isZeroValue ? "0m" : "-"; let minutes; let hours; let days; let extraHours = 0; let
                extraDays = 0;
            if (data) {
                minutes = Math.abs(data);

                if (minutes > 59) {
                    let dataMinutes = 0; let
                        remainingMinutes = 0;

                    dataMinutes = minutes / 60;
                    extraHours = Math.floor(dataMinutes);
                    remainingMinutes = extraHours > 0 ? minutes - (extraHours * 60) : 0;
                    if (remainingMinutes > 0) {
                        minutes = Math.floor(remainingMinutes);
                    } else {
                        minutes = 0;
                    }
                }

                if (extraHours > 23) {
                    let dataHours = 0; let
                        remainingHours = 0;
                    dataHours = extraHours / 24;
                    extraDays = Math.floor(dataHours);
                    remainingHours = extraDays > 0 ? extraHours - (extraDays * 24) : 0;
                    if (remainingHours > 0) {
                        hours = Math.floor(remainingHours);
                    } else {
                        hours = 0;
                    }
                } else if (extraHours) {
                    hours = extraHours;
                }

                if (extraDays) {
                    days = extraDays;
                }

                minutes = minutes ? `${minutes}m` : "";
                hours = hours ? `${hours}h` : "";
                days = days ? `${days}d` : "";
                response = days + (days && hours ? `, ${hours}` : hours) + ((days || hours) && minutes ? `, ${minutes}` : minutes);
            }

            return response;
        },
        getTaskStatusColor(status) {
            const item = this.allTasksStatus.find(elem => elem.id === status);
            return item && !this.isBlockchainEvent ? item.iconColor : "";
        },
        viewTaskDetails() {
            this.$emit("viewTaskDetails");
        },
        setMoreActions(data) {
            let response;
            if ((this.isOwner || this.hasWriteRT || this.hasWriteUC) && data.taskType !== "EXPOSE_API_PLUGIN" && !this.isBlockchainEvent) {
                response = (data.canUnclaim || data.canReassign || data.canEscalate);
            }
            return response;
        },
        getOptions(data) {
            let response = [];
            if (data.canUnclaim && data.canReassign) {
                response = this.moreOptions;
            } else if (data.canUnclaim) {
                response.push(this.moreOptions[0]);
            } else if (data.canReassign) {
                response.push(this.moreOptions[1]);
            }
            return response;
        },
        moreActionsTrigger() {
            this.$emit("moreActionsTrigger", this.moreActionModel[0].value);
            this.moreActionModel = [];
        }
    }
};
